(function ($) {
  if ($('.section--slider-5__wrapper .slider-wrapper').length) {

    $('.section--slider-5__wrapper .slider-wrapper').slick({
      arrows: false,
      dots: false,
      infinite: false,
      adaptiveHeight: true,
      slide: '.card--simple-horizontal-media-card',
      slidesToShow: 1,
      asNavFor: '.slider-nav',
      slidesToScroll: 1,
    });

    //slider nav for below main slider
    let slideLength = $('.section--slider-5__wrapper .slider-wrapper .card--simple-horizontal-media-card.slick-slide').length;
    console.log(slideLength);
    $('.slider-nav').slick({
      asNavFor: '.section--slider-5__wrapper .slider-wrapper',
      focusOnSelect: true,
      arrows: false,
      dots: true,
      infinite: false,
      draggable: true,
      appendDots: '.slide-nav__inner-dots',
      appendArrows: $('.slide-nav__inner-next'),
      speed: 100,
      slidesToShow: ( slideLength >= 2 ) ? 2 : slideLength,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 620,
          settings: {
            slidesToShow: ( slideLength >= 4 ) ? 4 : slideLength
          }
        },
      ]
    });

    // SLIDER NAV MINI START
    // $('.slider-nav__mini').slick({
    // 	slidesToShow: $('.section--slider-5__wrapper .slider-wrapper .card--simple-horizontal-media-card.slick-slide').length,
    // 	asNavFor: '.section--slider-5__wrapper .slider-wrapper,.slider-nav',
    // 	dots: false,
    // 	infinite: false,
    // 	arrows: true,
    // 	nextArrow: '<button type="button" class="slick-next">Next</button>'
    // });


    $('.section--slider-5__wrapper .slider-wrapper').on('afterChange', function (e, slick, currentSlide, nextSlide) {
      $('.section--slider-5__wrapper .slider-nav__mini--position').text('0' + (currentSlide + 1));
    });

    $('.slider-nav__mini__container .slide-nav__inner-prev').on('click', function () {
      $('.section--slider-5__wrapper .slider-wrapper').slick('slickPrev');
    });

    $('.slider-nav__mini__container .slide-nav__inner-next').on('click', function () {
      $('.section--slider-5__wrapper .slider-wrapper').slick('slickNext');
    });

    //SLIDER NAV MINI END

  }


})(jQuery);
